var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{ref:"toolContainer",staticClass:"tool_container",staticStyle:{"pointer-events":"all"},style:(_vm.toolStyle),attrs:{"data-moving":_vm.isToolMoving,"data-focused":_vm.isToolFocused,"data-selected":_vm.isToolSelected}},[_c('g',{attrs:{"id":"g_tool_bodyAndHandles"}},[_c(_vm.tool.attrib.type + 'CMP',_vm._b({tag:"component"},'component',{
                    ref       : _vm.id,
                    tool      : _vm.tool,
                    isToolFocused : _vm.isToolFocused,
                    isToolSelected : _vm.isToolSelected,
                    isToolDenteActive : _vm.isToolDenteActive,
                    isToolLocationActive : _vm.isToolLocationActive,
                    isToolLabelVisible : _vm.isToolLabelVisible,
                    isToolLocationVisible : _vm.isToolLocationVisible,
                    isToolActive : _vm.isToolActive,
                    isToolMoving : _vm.isToolMoving,
                    toolColor : _vm.toolColor,
                    fill      : _vm.toolColor,
                },false)),_c('g',{attrs:{"id":"g_tool_handles"}},_vm._l((_vm.tool.coords.pts),function(pt,idx){return _c('circle',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.showHandles),expression:"showHandles"}],key:idx,on:{"mouseover":function($event){_vm.hHover = true},"mouseleave":function($event){_vm.hHover = false}}},'circle',{
                        id    : `${_vm.id}-h[${idx}]`,
                        cx    : pt.x, 
                        cy    : pt.y,
                        class : {
                            toolHandle : (_vm.hHover),
                            toolHandleMov : _vm.isToolMoving,
                        },
                        style : {                   
                            '--tool-handle-radius': ((_vm.hHover ? _vm.sizes.hHoverFactor : 1) * ((_vm.isToolFocused && !_vm.hHover) ? _vm.focusedSizes.handle : _vm.sizes.handle)),      
                            fill : (_vm.hHover) ? 'yellow' : _vm.hColor(_vm.tool, idx)
                        }
                    },false))}),0)],1),_c('text',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.showLabel),expression:"showLabel"}],staticClass:"tool-label",attrs:{"filter":_vm.toolConfidence,"dominant-baseline":"middle","text-anchor":"middle"},on:{"mouseover":function($event){_vm.lHover = true},"mouseleave":function($event){_vm.lHover = false}}},'text',{
                id    : _vm.id + '-label',
//                    ref : label.id,
                x : _vm.tool.label.vLabel.x,
                y : _vm.tool.label.vLabel.y,
                style : _vm.toolLabel_style
            },false),[_c('title',[_vm._v(_vm._s(_vm.labelDesc))]),_vm._v(" "+_vm._s(_vm.tool.label.text + (_vm.tool.state.marked ? '*' : ''))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }